import React from 'react';
import { Segment, Header, Tab } from 'semantic-ui-react';
import axios from 'axios';


import ConnectedCandidatesPreview from './ConnectedCandidatesPreview';
import CandidatesPreview from './CandidatesPreview';
import PreviousCandidatesPreview from './PreviousCandidatesPreview';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;


export default class CandidatesTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            candidates: [],
            showCreateCandidate: false,
        };
    }


    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');
    }


    render() {
        const panes = [
            {
                menuItem: 'Aktivni kandidati ',
                render: () => <Tab.Pane ><CandidatesPreview /></Tab.Pane>,
            },
            {
                menuItem: 'Kandidati trenutne akademske godine',
                render: () => <Tab.Pane attached={false}><ConnectedCandidatesPreview /></Tab.Pane>,
            },
            {
                menuItem: 'Prethodni kandidati',
                render: () => <Tab.Pane attached={false}><PreviousCandidatesPreview /></Tab.Pane>,
            },

        ];
        return (
            <div>

                <h1> Kandidati </h1>

                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            Pregled kandidata
                        </Header>
                    </Segment>

                    <Segment>

                        <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} defaultActiveIndex={0} />


                    </Segment>


                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesTab/CandidatesTab.js